import { GoalGroupChartType } from 'Generated/graphql-types'

const config = { domain: 'FunderPlatform', subdomain: 'Goals' }

interface FunderUserInfo {
  userId: number
  userEmail: string
  funderOrgId: number
}

interface CollabGoalInfo {
  goalGroupId: number | null
  funderUserInfo: FunderUserInfo
}

interface CollabGoalFilterValues {
  collabGoalInfo: CollabGoalInfo
  chartFilterValue: string
  chartType: string
}

interface GoalSharedWithFunderInfo {
  funderUserInfo: FunderUserInfo
  goalId: number
  goalType: string
}

interface ChartToggleInfo {
  chartType: string
  goalId: number
  funderUserInfo: FunderUserInfo
  toggleLabel: string
}

interface EditGoalInfo {
  groupGoalId: number
  funderUserInfo: FunderUserInfo
  collabGoalInfo: CollabGoalInfo
}

export const funderGoals = {
  Funder_Collab_Goal_Clicked: {
    Funder_Collab_Goal_Clicked: (param: CollabGoalInfo) => param,
    config,
  },
  Goal_Shared_With_Funder_Clicked: {
    Goal_Shared_With_Funder_Clicked: (param: GoalSharedWithFunderInfo) => param,
    config,
  },
  Funder_Add_Goal_Clicked: {
    Funder_Add_Goal_Clicked: (param: FunderUserInfo) => param,
    config,
  },
  Funder_Collab_Goal_Tab_Clicked: {
    Funder_Collab_Goal_Tab_Clicked: (param: CollabGoalInfo) => param,
    config,
  },
  Funder_Collab_Goal_Chart_Filter_Clicked: {
    Funder_Collab_Goal_Chart_Filter_Clicked: (param: CollabGoalFilterValues) =>
      param,
    config,
  },
  Funder_Collab_Goal_Chart_Toggle_Clicked: {
    Funder_Collab_Goal_Chart_Toggle_Clicked: (param: ChartToggleInfo) => param,
    config,
  },
  Funder_Goal_Progress_Chart_Data_Point_Hovered: {
    Funder_Goal_Progress_Chart_Data_Point_Hovered: (param: {
      goalGroupId: number
      goalGroupChartType: GoalGroupChartType
      dataPoint: string
    }) => param,
    config,
  },
  Funder_Collab_Goal_Edit_Saved: {
    Funder_Collab_Goal_Edit_Saved: (param: EditGoalInfo) => param,
    config,
  },
  Funder_Collab_Goal_Edit_Goal_Clicked: {
    Funder_Collab_Goal_Edit_Goal_Clicked: (param: { groupGoalId: number }) =>
      param,
    config,
  },
}
